'use strict';

class DatosIntegrantesController {
  constructor() {

  }


}

export default DatosIntegrantesController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/datos-integrantes/datos-integrantes.controller.js